<template>
    <submit-button class="ml-2 text-sm" size="sm" @click.prevent="show = true;">Adicionar Feature Flag</submit-button>
    <modal
        class="min-h-full"
        :open="featureFlag || show"
        @close="show = false"
    >
        <div class="flex flex-col flex-wrap w-full space-y-3 text-white divide-y divide-slate-500 min-h-fit">
        </div>
        <h1 class="flex flex-row flex-wrap items-center content-center pb-1 mb-2 text-sm text-lg font-bold text-white border-b border-slate-500">
            Adicionar Feature Flag
        </h1>

        <feature-flag-form @fetch="show= false;$emit('fetch');$emit('resetFeatureFlags')" :featureFlag="featureFlag" />
    </modal>
</template>

<script>
    import Modal from "../../layouts/Modal.vue";
    import SubmitButton from "../../forms/SubmitButton.vue";
    import FeatureFlagForm from "../FeatureFlagForm.vue";

    export default {
        props: {featureFlag: {type: Object, default: null}},
        components: {FeatureFlagForm, SubmitButton, Modal},
        emits: ['fetch'],
        data() {
            return {
                show: false,
            }
        },
    }
</script>